import { render } from "./Historia.vue?vue&type=template&id=830963ca"
import script from "./Historia.vue?vue&type=script&lang=js"
export * from "./Historia.vue?vue&type=script&lang=js"

import "./Historia.vue?vue&type=style&index=0&id=830963ca&lang=css"

import exportComponent from "C:\\Users\\Fernando\\Desktop\\curso Innovaccion Virtual\\FrontEnd\\Practica5 VUE\\pasteleria-vuex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__